import type { Router } from 'vue-router'
import { ofetch } from 'ofetch'
import { canNavigate } from '@layouts/plugins/casl'
import { App } from '@/types/generated'
import UserData = App.Http.Controllers.Auth.UserData

export const setupGuards = (router: Router) => {
  // 👉 router.beforeEach
  // Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
  router.beforeEach(to => {
    const isLoggedIn = !!(useCookie('userData').value)

    if (!isLoggedIn && to.meta.public) {
      ofetch.raw('/sanctum/csrf-cookie').then(() => {
      })
    }

    const isEmailVerified = useCookie<UserData>('userData')?.value?.isEmailVerified

    /*
      If user is logged in and is trying to access login like page, redirect to home
      else allow visiting the page
      (WARN: Don't allow executing further by return statement because next code will check for permissions)
     */
    if (to.meta.unauthenticatedOnly) {
      if (isLoggedIn)
        return '/'
      else
        return undefined
    }

    if (to.meta.unverifiedOnly) {
      if (!isLoggedIn)
        return '/'

      if (isEmailVerified)
        return '/'
      else
        return undefined
    }

    /*
   * If it's a public route, continue navigation. This kind of pages are allowed to visited by login & non-login users. Basically, without any restrictions.
   * Examples of public routes are, 404, under maintenance, etc.
   */
    if (to.meta.public)
      return

    if (!canNavigate(to) && to.matched.length) {
      /* eslint-disable indent */
      return isLoggedIn
        ? { name: 'index' }
        : {
            name: 'login',
            query: {
              ...to.query,
              to: to.fullPath !== '/' ? to.path : undefined,
            },
          }
      /* eslint-enable indent */
    }
  })
}
